<template>
  <div class="wrap">
    <el-date-picker v-model="queryParams.dealtime" type="monthrange" value-format="yyyy-MM" start-placeholder="开始日期" end-placeholder="结束日期" @change="onSearch()" />
    <el-card v-loading="loading" :body-style="{ padding: '0px' }" shadow="never">
      <el-scrollbar>
        <dl>
          <dd v-for="(row, index) in categoryData" :key="'c' + index" @click="onSearch({ category: row.name })" :class="{ current: queryParams.category == row.name }">
            <span class="index">{{ index + 1 }}</span>
            <span class="name">{{ row.name }}</span>
            <span class="value">{{ row.value }}</span>
          </dd>
        </dl>
        <dl>
          <dd v-for="(row, index) in regionData" :key="'r' + index" @click="onSearch({ region: row.name })" :class="{ current: queryParams.region == row.name }">
            <span class="index">{{ index + 1 }}</span>
            <span class="name">{{ row.name }}</span>
            <span class="value">{{ row.value }}</span>
          </dd>
        </dl>
      </el-scrollbar>
    </el-card>
    <monthChart ref="chart" :params="queryParams" style="grid-row-start: span 2" />
  </div>
</template>

<script>
export default {
  components: {
    monthChart: () => import('./charts/_month.vue')
  },
  data () {
    return {
      loading: false,
      regionData: [],
      categoryData: [],
      queryParams: {
        dealtime: [new Date(new Date().getFullYear(), 0), new Date(new Date().getFullYear(), 11)]
      }
    }
  },
  mounted () {
    this.loadRegions()
    this.loadCategorys()
  },
  methods: {
    onSearch (key = {}) {
      this.queryParams = { ...this.queryParams, ...key }
      this.$refs.chart.params = this.queryParams
      this.$refs.chart.loadData()
      this.loadRegions()
      this.loadCategorys()
    },
    loadRegions () {
      this.$apis.trend.region.sales(this.queryParams).then(res => {
        this.regionData = res.items
      })
    },
    loadCategorys () {
      this.$apis.trend.category.sales(this.queryParams).then(res => {
        this.categoryData = res.items
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 300px 1fr;
  grid-template-rows: auto 1fr;
  grid-gap: 16px;
  position: relative;
  .search {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 9999;
  }

  .total {
    padding: 15px 20px;
    background: #fff;
    position: sticky;
    top: 0;
  }

  dl {
    padding: 20px;
    dd + dd {
      margin-top: 20px;
    }
    dd {
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .index {
        background-color: #ccc;
        color: #fff;
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: 10px;
        display: inline-block;
        text-align: center;
      }
      &:first-child {
        .index {
          background: #f00;
        }
      }
      &.current {
        color: #409eff;
        .index {
          background: #409eff;
        }
      }
      .name {
        flex: 1;
      }
      .value {
        &::after {
          content: '万';
          font-size: 50%;
        }
      }
    }
  }
}
</style>